module.exports = __webpack_public_path__ + "officialStatic/img/new12.ae51527.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/new12.jpg
// module id = j/i5
// module chunks = 0